<router-outlet></router-outlet>

<ic-loader></ic-loader>
